import fetchBaseQuery from '@app/api/fetchBaseQuery'
import { createApi } from '@reduxjs/toolkit/query/react'

import type { GetOtaTeamUsageRequest, GetOtaUsageRequest, GetOtaUsageResponse } from './types'

const statisticsApi = createApi({
	reducerPath: 'lokaliseInternal_statistics',
	baseQuery: fetchBaseQuery(),
	endpoints: (builder) => ({
		getOtaStatistics: builder.query<GetOtaUsageResponse, GetOtaUsageRequest>({
			query: ({ projectId }) => ({
				method: 'GET',
				url: `/ota/${projectId}/traffic`,
			}),
		}),
		getOtaTeamStatistics: builder.query<GetOtaUsageResponse, GetOtaTeamUsageRequest>({
			query: ({ teamId }) => ({
				method: 'GET',
				url: `/ota/team/${teamId}/traffic`,
			}),
		}),
	}),
})

export default statisticsApi

export const {
	useGetOtaStatisticsQuery,
	useLazyGetOtaTeamStatisticsQuery,
	useGetOtaTeamStatisticsQuery,
} = statisticsApi
